import { HttpClient, MHTTPCL } from "../../../services/http/http-client";
import { MODIFICATION_URL, EXT_REQUEST } from "../../../services/common-urls";
import { BOOKING_URL, BOOKINGS_STRING, CALENDAR_DATES_STRING } from "./booking-service";

const SECTION_BOOKING_REQUESTS = 'booking_requests';

const EXT_REQUEST_URL = '/ext_request.pl';
export const bookingRequestsService = {
    getCityList: (searchTerm) => {
        return MHTTPCL.get(EXT_REQUEST, {

            action: 'get_city',
            term: searchTerm,

        })
    },

    getVenueContext: (booking_location_id, start_date) => {
        MHTTPCL.get(BOOKING_URL, {
            section: "bookings",
            action: "get_venue_context",
            booking_location_id: booking_location_id,
            start_date: start_date,
            promoter_id: 0,
            contact_id: 0

        })
    },

    getCustomData: (external_id, external_table) => {
        MHTTPCL.post(BOOKING_URL, {
            section: "booking_requests",
            action: "get_custom_data",
            external_table: external_table,
            external_id: external_id,
        })
    },


    getVenueContextPromoter: (promoter_id) => {
        MHTTPCL.get3(BOOKING_URL, {
            section: "bookings",
            action: "get_venue_context",
            booking_location_id: "",
            start_date: "",
            promoter_id: promoter_id,
            contact_id: 0

        })
    },







    getBookingRequests: () => {
        return HttpClient.post(BOOKING_URL, {
            section: SECTION_BOOKING_REQUESTS,
            action: 'booking_requests'
        });
    },

    getBookingRequest: (calendar_date_id, artistID) => {
        return HttpClient.get(BOOKING_URL, {
            section: SECTION_BOOKING_REQUESTS,
            action: 'booking_request_wizard',
            calendar_date_id: calendar_date_id,
            artist_id: artistID
        });
    },

    deleteBookingRequest: (calendar_date_id) => {
        return HttpClient.post(BOOKING_URL, {
            section: SECTION_BOOKING_REQUESTS,
            action: 'remove_booking_request',
            calendar_date_id: calendar_date_id
        });
    },

    searchPromoterByName: ({
        searchString
    }) => HttpClient.get3(EXT_REQUEST_URL, {
        action: 'get_promoter',
        term: searchString,
        promoter_search_by: 'promoter_company_name'
    }),

    searchContactByName: ({
        searchString
    }) => HttpClient.post(EXT_REQUEST_URL, {
        action: 'get_contact',
        term: searchString
    }),
    processBookingRequest: ({
        data
    }) => HttpClient.post(BOOKING_URL, {
        section: 'booking_requests',
        action: 'process_booking_request',
        data: JSON.stringify(data)
    })
};
